<template>
  <el-dialog :visible.sync="dialogVisible" width="72rem" :show-close="false" custom-class="credits-dialog">
    <div class="dialog-header">
      <div class="header-left">
        <span class="title">玩转AI短剧，人人都是戏精！</span>
      </div>
      <div class="header-right">
        <i class="el-icon-close" @click="dialogVisible = false"></i>
      </div>
    </div>

    <div class="dialog-body">
      <!-- 用户信息栏 -->
      <div class="user-info-bar">
        <div class="user-left">
          <img src="@/assets/logo.png" alt="" class="user-avatar">
          <span class="phone">{{ userInfo.mobile }}</span>
          <div class="credits-badge">
            <i class="el-icon-lightning"></i>
            <span>{{ userInfo.points }}</span>
          </div>
        </div>
        <div class="user-right">
          <el-button size="small" class="redeem-btn" @click="showRedeemDialog = true">兑换码</el-button>
        </div>
      </div>

      <!-- 标签页 -->
      <div class="tabs-container">
        <div class="tabs-wrapper">
          <div class="tabs-header">
            <div class="tab-item" :class="{ active: activeTab === 'membership' }" @click="activeTabclick('membership')">
              会员计划
            </div>
            <div class="tab-item" :class="{ active: activeTab === 'recharge' }" @click="activeTabclick('recharge')">
              充算力
            </div>
            <div class="tab-item" :class="{ active: activeTab === 'history' }" @click="activeTabclick('history')">
              算力记录
            </div>
          </div>
          <div class="tabs-hint">算力有效期两年，到期自动清零</div>
        </div>
      </div>

      <!-- 会员计划内容 -->
      <div v-if="activeTab === 'membership'" class="membership-content">
        <div class="membership-grid">
          <div v-for="(plan, index) in membershipPlans" :key="index" class="membership-card" :class="{
            'is-free': index == 0,
            'is-selected': selectedPlan === plan.id,
          }" @click="handleSelectPlan(plan, index)">
            <!-- 'is-best': plan.type === 'yearly', -->
            <div v-if="plan.type === 'yearly'" class="best-badge">最优惠</div>
            <div class="card-header">
              <h3 class="plan-title">{{ plan.memberCardName }}</h3>
              <div class="plan-price">
                <span class="currency">¥</span>
                <span class="amount">{{ plan.preferentialPrice }}</span>
              </div>
              <div class="plan-validity">
                <span v-if="plan.validity"> {{ plan.validity }}</span>
              </div>
            </div>
            <el-button :class="['purchase-btn', { 'is-yearly': plan.type === 'yearly' }]"
              :disabled="plan.type === 'free'" @click.stop="handlePurchaseMembership(plan, index)">
              {{ index === 0 ? '免费版本' : '购买' + plan.memberCardName }}
            </el-button>
            <div class="features-list">
              <div v-for="(feature, fIndex) in plan.features" :key="fIndex" class="feature-item">
                <i class="el-icon-check"></i>
                <span>{{ feature }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 充算力内容 -->
      <div v-if="activeTab === 'recharge'" class="recharge-content">
        <div class="current-plan">
          <i class="el-icon-lightning"></i>
          <span>当前：{{ userInfo.memberType || '免费会员' }}</span>
        </div>
        <div class="recharge-grid">
          <div v-for="(pkg, index) in aiPointslist" :key="index" class="recharge-card"
            :class="{ 'is-selected': selectedRechargePackage == index }" @click="handleSelectRecharge(index)">
            <div class="credits-amount">
              <i class="el-icon-lightning"></i>
              <span>{{ pkg.points }}</span>
            </div>
            <div class="credits-price">
              <span class="currency">¥</span>
              <span class="amount">{{ pkg.amount }}</span>
            </div>
            <el-button class="buy-btn" @click.stop="handlePurchaseCredits(pkg, index)">
              立即购买
            </el-button>
          </div>
        </div>
      </div>

      <!-- 算力记录内容 -->
      <div v-if="activeTab === 'history'" class="history-content">
        <div class="history-list">
          <div v-for="(record, index) in aiPointsFlowlist" :key="index" class="history-item">
            <div class="record-left">
              <div class="record-title">{{ record.inOutDetail }}</div>
              <div class="record-time">{{ record.createTime }}</div>
            </div>
            <div class="record-right">
              <div>
                <span :class="['record-amount', { 'is-negative': record.points < 0 }]">
                  {{ record.points > 0 ? "+" : "" }}{{ record.points }}
                </span>
              </div>
              <div class="record-balance">
                剩余算力：{{ record.balancePoints }}
              </div>

            </div>
          </div>
        </div>
        <div class="pagination-wrapper">
          <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
            :current-page.sync="pageNum" @current-change="getaiPointsFlowlist">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 兑换码弹窗 -->
    <el-dialog :visible.sync="showRedeemDialog" width="560px" custom-class="redeem-dialog" :append-to-body="true">
      <div slot="title" class="redeem-title">兑换码</div>
      <el-input v-model="redeemCode" placeholder="请输入兑换码" size="large"></el-input>
      <div slot="footer" class="redeem-footer">
        <el-button @click="showRedeemDialog = false" class="cancel-btn">取消</el-button>
        <el-button type="primary" @click="handleRedeem" class="redeem-confirm-btn">兑换</el-button>
      </div>
    </el-dialog>

    <!-- 微信扫码支付弹窗 -->
    <el-dialog :visible.sync="showPaymentDialog" width="420px" custom-class="payment-qr-dialog" :append-to-body="true"
      center :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="payment-qr-content">
        <div class="payment-qr-header">
          <i class="el-icon-chat-dot-round wechat-icon"></i>
          <span class="payment-qr-title">微信扫码付款</span>
        </div>
        <div class="payment-qr-body">
          <div class="qrcode-wrapper">
            <div v-if="paymentQrLoading" class="qrcode-loading">
              <i class="el-icon-loading"></i>
              <span>生成二维码中...</span>
            </div>
            <img v-else-if="paymentQrDataUrl" :src="paymentQrDataUrl" class="qrcode-img" alt="支付二维码" />
            <div v-else class="qrcode-placeholder"></div>
          </div>
          <div class="payment-qr-tips">请扫码以完成支付</div>
        </div>
        <div class="payment-qr-footer">
          <el-button class="cancel-payment-btn" @click="handleCancelPayment">取消支付</el-button>
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import QRCode from "qrcode";
import { EventBus,EVENTS } from "@/utils/eventBus";
import { ainewMemberCardlist,ainewAiSettinginfo,userInfo,useraiCard,aiPointslist,aiPointsFlowlist,alipaywebpay } from "@/api";
export default {
  name: "CreditsDialog",
  data() {
    return {
      dialogVisible: false,
      activeTab: "membership",
      selectedPlan: "",
      selectedRechargePackage: null,
      showRedeemDialog: false,
      redeemCode: "",
      showPaymentDialog: false,
      paymentQrDataUrl: "",
      paymentQrLoading: false,
      currentPaymentItem: null,
      membershipPlans: [
        {
          type: "free",
          title: "免费",
          price: 0,
          validity: "永久有效",
          buttonText: "免费版本",
          features: ["注册送100算力","邀请送算力"],
        },
        {
          type: "monthly",
          title: "月会员",
          price: 69,
          buttonText: "购买月会员",
          features: [
            "690 算力",
            "约生成180张图或690秒视频",
            "注册送100算力",
            "邀请送算力",
            "数字人对口型",
            "免费声音克隆",
            "批量生成主体",
            "批量生成入镜",
          ],
        },
        {
          type: "quarterly",
          title: "季会员",
          price: 198,
          buttonText: "购买季会员",
          features: [
            "2100 算力",
            "约生成4200张图或2100秒视频",
            "注册送100算力",
            "算力充值额外享9.5折",
            "邀请送算力",
            "数字人对口型",
            "免费声音克隆",
            "批量生成主体",
          ],
        },
        {
          type: "yearly",
          title: "年会员",
          price: 698,
          buttonText: "购买年会员",
          features: [
            "8000 算力",
            "约生成17000张图或8000秒视频",
            "注册送100算力",
            "算力充值额外享85折",
            "邀请送算力",
            "数字人对口型",
            "免费声音克隆",
            "批量生成主体",
          ],
        },
      ],

      aiPointslist: [],


      userInfo: {},
      pageNum: 1,
      pageSize: 10,
      total: 0,
      aiPointsFlowlist: []
    };
  },
  created() {
    this.getainewAiSettinginfo()
    this.getuserInfo()
    this.getaiPointslist()
  },
  mounted() {
    EventBus.$on(EVENTS.SHOW_CREDITS_DIALOG,() => {
      this.dialogVisible = true;
    });
  },
  beforeDestroy() {
    document.body.classList.remove("payment-dialog-open");
    EventBus.$off(EVENTS.SHOW_CREDITS_DIALOG);
  },
  watch: {
    showPaymentDialog(val) {
      if(val) {
        document.body.classList.add("payment-dialog-open");
      } else {
        document.body.classList.remove("payment-dialog-open");
      }
    },
  },
  methods: {
    activeTabclick(tab) {
      this.activeTab = tab;
      this.getaiPointsFlowlist();
    },
    getaiPointsFlowlist() {
      aiPointsFlowlist({
        userId: localStorage.getItem("userId"),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then(res => {
        if(res.code == 200) {
          this.aiPointsFlowlist = res.rows;
          this.total = res.total
        }
      })
    },
    getaiPointslist() {
      aiPointslist({
        pageNum: 1,
        pageSize: 999,
      }).then(res => {
        if(res.code == 200) {
          this.aiPointslist = res.rows;
        }
      })
    },
    getuserInfo() {
      if(!localStorage.getItem("userId")) return;
      userInfo({
        userId: localStorage.getItem("userId"),
      }).then(res => {
        if(res.code == 200) {
          this.userInfo = res.data;
          if(this.userInfo.mobile) {
            this.userInfo.mobile = this.userInfo.mobile.replace(/(\d{3})\d{4}(\d{4})/,'$1****$2');
          }
        }
      })
    },
    getainewAiSettinginfo() {
      ainewAiSettinginfo({}).then(res => {
        if(res.code == 200) {
          this.AiSettinginfo = res.data;
          this.getainewMemberCardlist(res.data.registerGiveComputingPower)

        }
      })
    },
    getainewMemberCardlist(registerGiveComputingPower) {
      ainewMemberCardlist({
        pageNum: 1,
        pageSize: 999,
      }).then(res => {
        if(res.code == 200) {
          let membershipPlans = res.rows;
          this.membershipPlans = membershipPlans.map(i => {
            let features = [
              `${i.givePoints} 算力`,
              `约生成${i.givePoints * 2}张图或${i.givePoints * 1000}秒视频`,
              `注册送${registerGiveComputingPower}算力`,
              `算力充值额外享${i.rechargeDiscount}折`,
              `邀请送算力`,
              `数字人对口型`,
              `免费声音克隆`,
              `批量生成主体`,
              `批量生成分镜`,
              `批量导出素材`,
              `快速生成通道`,
            ]
            if(!i.rechargeDiscount) {
              features.splice(2,1);
            }
            return {
              ...i,
              ['features']: features
            }
          })
          this.membershipPlans.unshift({
            memberCardName: "免费",
            preferentialPrice: 0,
            validity: "永久有效",
            buttonText: "免费版本",
            features: [`注册送${registerGiveComputingPower}算力`,"邀请送算力"],

          });
        }
      })
    },
    handleSelectPlan(plan,index) {
      if(index == 0) return;
      this.selectedPlan = plan.id;
    },
    handleSelectRecharge(index) {
      this.selectedRechargePackage = index;
    },
    handlePurchaseMembership(plan,index) {
      if(index == 0) return;
      // this.selectedPlan = plan.id;
      // this.currentPaymentItem = { type: "membership", data: plan };
      // this.showPaymentDialog = true;
      alipaywebpay({
        // userId: localStorage.getItem("userId"),
        amount: plan.preferentialPrice,
        content: plan.id,
        type: 1,
        // 
      }).then(res => {
        if(res.code == 200) {
          let html = res.msg;
          // 1. 先把字符串里的转义双引号 \" 变成正常的 "
          html = html.replace(/\\"/g,'"');
          // 2. 去掉换行符 \n
          html = html.replace(/\\n/g,'');
          // 3. 去掉首尾多余的引号（如果有的话）
          if(html.startsWith('"') && html.endsWith('"')) {
            html = html.slice(1,-1);
          }
          document.open();
          document.write(html);
          document.close();
          // this.generatePaymentQrCode(payurl);
          // this.paymentQrDataUrl = res.data.qrCode;
          // this.onPaymentDialogOpened(res.data.payUrl);
        }
      })
    },
    handlePurchaseCredits(val,index) {
      let memberType = userInfo.memberType
      let member = this.membershipPlans.find(i => i.memberCardName == memberType)
      let zheko = 1
      if(member == 0 || member) {
        zheko = this.membershipPlans[member].rechargeDiscount / 100
      } else {
        zheko = 1
      }
      let amount = val.amount * zheko
      alipaywebpay({
        // userId: localStorage.getItem("userId"),
        amount: amount,
        content: val.points,
        type: 2,
      }).then(res => {
        if(res.code == 200) {
          let html = res.msg;
          // 1. 先把字符串里的转义双引号 \" 变成正常的 "
          html = html.replace(/\\"/g,'"');
          // 2. 去掉换行符 \n
          html = html.replace(/\\n/g,'');
          // 3. 去掉首尾多余的引号（如果有的话）
          if(html.startsWith('"') && html.endsWith('"')) {
            html = html.slice(1,-1);
          }
          document.open();
          document.write(html);
          document.close();
        }
      })
      // this.selectedRechargePackage = index;
      // this.currentPaymentItem = { type: "credits", data: pkg };
      // this.showPaymentDialog = true;
    },
    onPaymentDialogOpened() {
      this.paymentQrDataUrl = "";
      this.paymentQrLoading = true;
      this.$nextTick(() => {
        this.generatePaymentQrCode();
      });
    },
    async generatePaymentQrCode(payUrl) {
      try {
        const dataUrl = await QRCode.toDataURL(payUrl,{
          width: 250,
          margin: 2,
          color: { dark: "#000000",light: "#ffffff" },
        });
        this.paymentQrDataUrl = dataUrl;
      } catch(err) {
        this.$message.error("二维码生成失败");
        console.error(err);
      } finally {
        this.paymentQrLoading = false;
      }
    },
    handleCancelPayment() {
      this.showPaymentDialog = false;
      this.paymentQrDataUrl = "";
      this.paymentQrLoading = false;
      this.currentPaymentItem = null;
    },
    handlePageChange(page) {
      console.log("[v0] Page changed:",page);
    },
    handleRedeem() {
      if(!this.redeemCode) {
        this.$message.warning("请输入兑换码");
        return;
      }
      useraiCard({
        cardNo: this.redeemCode,
        userId: localStorage.getItem("userId"),
      }).then(res => {
        if(res.code == 200) {
          this.$message.success("兑换成功");
          this.showRedeemDialog = false;
          this.redeemCode = "";
          this.getuserInfo();
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .credits-dialog {
  min-width: 1000px;
  max-width: 72rem;
  height: 85vh;
  background-color: #1a1a1a;
  border-radius: 12px;
  display: flex;
  flex-direction: column;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #2d2d2d;

  .title {
    font-size: 16px;
    color: #fff;
  }

  .el-icon-close {
    font-size: 20px;
    color: #999;
    cursor: pointer;

    &:hover {
      color: #fff;
    }
  }
}

.dialog-body {
  padding: 20px 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.user-info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background-color: #2d2d2d;
  border-radius: 8px;
  margin-bottom: 20px;

  .user-left {
    display: flex;
    align-items: center;
    gap: 16px;

    .user-avatar {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      object-fit: cover;
    }

    .phone {
      font-size: 16px;
      color: #fff;
    }

    .credits-badge {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 6px 12px;
      background-color: #3d3d3d;
      border-radius: 6px;

      i {
        color: #8bff8b;
        font-size: 16px;
      }

      span {
        font-size: 16px;
        font-weight: 600;
        color: #fff;
      }
    }
  }

  .redeem-btn {
    background-color: #3d3d3d;
    border-color: #4d4d4d;
    color: #fff;

    &:hover {
      background-color: #4d4d4d;
    }
  }
}

.tabs-container {
  margin-bottom: 20px;
  flex-shrink: 0;

  .tabs-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #2d2d2d;
  }

  .tabs-header {
    display: flex;
    gap: 40px;

    .tab-item {
      padding: 12px 0;
      font-size: 15px;
      color: #888;
      cursor: pointer;
      position: relative;
      transition: color 0.2s;

      &:hover {
        color: #aaa;
      }

      &.active {
        color: #8bff8b;

        &::after {
          content: "";
          position: absolute;
          bottom: -1px;
          left: 0;
          right: 0;
          height: 2px;
          background-color: #8bff8b;
        }
      }
    }
  }

  .tabs-hint {
    font-size: 12px;
    color: #666;
    padding-bottom: 12px;
    white-space: nowrap;
  }
}

.membership-content {
  flex: 1;
  overflow-y: auto;

  .membership-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }

  .membership-card {
    position: relative;
    padding: 20px;
    background-color: #2d2d2d;
    border: 2px solid #3d3d3d;
    border-radius: 8px;
    transition: all 0.2s;
    cursor: pointer;

    &:hover:not(.is-free) {
      border-color: #5d5d5d;
    }

    &.is-free {
      cursor: not-allowed;

      .purchase-btn {
        background-color: #3d3d3d;
        border-color: #4d4d4d;
        color: #666;
        cursor: not-allowed;


      }
    }

    &.is-selected:not(.is-free) {
      border-color: #8bff8b;
      background: hsl(120deg 100% 84.09% / 11%);

      .purchase-btn {
        background: rgb(146 255 146 / 77%);
        border-color: rgb(146 255 146 / 77%);
        color: #000000;
      }
    }

    &.is-best {
      border-color: #8bff8b;

      .purchase-btn {
        background-color: #8bff8b;
        border-color: #8bff8b;
        color: #1a1a1a;

        &:hover {
          background-color: #7aee7a;
        }
      }
    }

    .best-badge {
      position: absolute;
      top: 5px;
      right: 8px;
      padding: 4px 12px;
      background-color: #8bff8b;
      border-radius: 12px;
      font-size: 11px;
      color: #1a1a1a;
      font-weight: 600;
    }

    .card-header {
      text-align: center;
      margin-bottom: 16px;

      .plan-title {
        font-size: 18px;
        color: #fff;
        margin-bottom: 12px;
      }

      .plan-price {
        .currency {
          font-size: 14px;
          color: #fff;
        }

        .amount {
          font-size: 32px;
          font-weight: 600;
          color: #fff;
        }
      }

      .plan-validity {
        margin-top: 8px;
        font-size: 12px;
        color: #888;
        height: 20px;
      }
    }

    .purchase-btn {
      width: 100%;
      margin-bottom: 20px;
      background-color: #3d3d3d;
      border-color: #4d4d4d;
      color: #fff;

      // &:hover:not(:disabled) {
      //   background-color: #4d4d4d;
      // }
    }

    .features-list {
      .feature-item {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 10px;
        font-size: 13px;
        color: #aaa;

        i {
          color: #8bff8b;
          font-size: 14px;
          margin-top: 2px;
          flex-shrink: 0;
        }
      }
    }
  }
}

.recharge-content {
  flex: 1;
  overflow-y: auto;

  .current-plan {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 12px 16px;
    background-color: #2d2d2d;
    border-radius: 20px;
    width: fit-content;
    margin-bottom: 24px;

    i {
      color: #8bff8b;
      font-size: 16px;
    }

    span {
      font-size: 13px;
      color: #fff;
    }
  }

  .recharge-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .recharge-card {
    padding: 20px 15px;
    background-color: #2d2d2d;
    border: 2px solid #3d3d3d;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: #5d5d5d;
    }

    &.is-selected {
      border-color: #8bff8b;
      background: hsl(120deg 100% 84.09% / 11%);

      .buy-btn {
        background: rgb(146 255 146 / 77%);
        border-color: rgb(146 255 146 / 77%);
        color: #000000;
      }
    }

    .credits-amount {
      display: flex;
      align-items: center;
      // justify-content: center;
      gap: 8px;
      margin-bottom: 12px;

      i {
        color: #8bff8b;
        font-size: 24px;
      }

      span {
        font-size: 28px;
        font-weight: 600;
        color: #fff;
      }
    }

    .credits-price {
      margin-bottom: 18px;
      text-align: left;

      .currency {
        font-size: 14px;
        color: #888;
      }

      .amount {
        font-size: 20px;
        color: #fff;
      }
    }

    .buy-btn {
      width: 100%;
      background-color: #3d3d3d;
      border-color: #4d4d4d;
      color: #fff;


    }
  }
}

.history-content {
  flex: 1;
  padding-right: 15px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  .history-list {
    flex: 1;
    margin-bottom: 24px;
  }

  .history-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 10px 16px 0px;
    border-bottom: 1px solid #2d2d2d;

    .record-left {
      .record-title {
        font-size: 14px;
        color: #fff;
        margin-bottom: 6px;
      }

      .record-time {
        font-size: 12px;
        color: #666;
      }
    }

    .record-right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .record-amount {
        font-size: 16px;
        font-weight: 600;
        color: #8bff8b;

        &.is-negative {
          color: #ff6b6b;
        }
      }

      .record-balance {
        font-size: 13px;
      }
    }
  }

  .pagination-wrapper {
    display: flex;
    justify-content: center;

    ::v-deep .el-pagination {

      .btn-prev,
      .btn-next,
      .el-pager li {
        background-color: #2d2d2d;
        color: #888;

        &:hover {
          color: #fff;
        }

        &.active {
          background-color: #8bff8b;
          color: #1a1a1a;
        }
      }
    }
  }
}

::v-deep .redeem-dialog {
  background-color: #2d2d2d;
  border-radius: 8px;

  .el-dialog__header {
    padding: 24px 24px 20px;
    border-bottom: 1px solid #3d3d3d;
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 0 24px 24px;
  }

  .el-input__inner {
    background-color: #3d3d3d;
    border-color: #4d4d4d;
    color: #fff;
    height: 48px;
    font-size: 15px;

    &::placeholder {
      color: #666;
    }

    &:focus {
      border-color: #8bff8b;
    }
  }
}

.redeem-title {
  font-size: 18px;
  color: #fff;
  font-weight: 500;
}

.redeem-footer {
  display: flex;
  gap: 12px;

  .el-button {
    flex: 1;
    height: 44px;
    font-size: 15px;
  }

  .cancel-btn {
    background-color: #3d3d3d;
    border-color: #4d4d4d;
    color: #fff;

    &:hover {
      background-color: #4d4d4d;
    }
  }

  .redeem-confirm-btn {
    background-color: #8bff8b;
    border-color: #8bff8b;
    color: #1a1a1a;

    &:hover {
      background-color: #7aee7a;
    }
  }
}

/* 微信扫码支付弹窗 */
::v-deep .payment-qr-dialog {
  background-color: #2d2d2d;
  border-radius: 12px;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.payment-qr-content {
  padding: 0;
}

.payment-qr-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 28px 24px 20px;

  .wechat-icon {
    font-size: 28px;
    color: #07c160;
  }

  .payment-qr-title {
    font-size: 18px;
    font-weight: 500;
    color: #fff;
  }
}

.payment-qr-body {
  padding: 0 32px 24px;

  .qrcode-wrapper {
    width: 250px;
    height: 250px;
    margin: 0 auto 20px;
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .qrcode-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    color: #666;
    font-size: 14px;

    .el-icon-loading {
      font-size: 32px;
      color: #07c160;
    }
  }

  .qrcode-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .qrcode-placeholder {
    width: 100%;
    height: 100%;
  }

  .payment-qr-tips {
    text-align: center;
    font-size: 14px;
    color: #fff;
  }
}

.payment-qr-footer {
  padding: 0 24px 28px;

  .cancel-payment-btn {
    width: 100%;
    height: 48px;
    font-size: 16px;
    background-color: #3d3d3d;
    border-color: #4d4d4d;
    color: #fff;
    border-radius: 8px;

    &:hover {
      background-color: #4d4d4d;
    }
  }
}
</style>

<style lang="scss">
/* 支付弹窗打开时，该弹窗的遮罩层加深，使背景页面难以看清 */
body.payment-dialog-open .v-modal {
  opacity: 1 !important;
  background-color: rgba(0, 0, 0, 0.85) !important;
}
</style>
